import React, { useState } from "react";
import logoPgmWhite from "../../assets/images/landingPage/logo-pgm-white-mode.svg";
import TextLink from "../TextLink";
import Button from "../Button";
import ModalBalcaoVirtual from "../v2/ModalBalcaoVirtual";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import style from "./styles.module.scss";

interface FooterSidebarProps {
  side: "left" | "right";
}

function FooterSidebar({ side }: FooterSidebarProps) {
  const sidebarClassName = [
    style.footerSidebar,
    side === "right" ? style.footerSidebarRight : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div aria-hidden="true" className={sidebarClassName}>
      <div className={style.footerSidebarSection1}>
        <div className={style.footerSidebarBackground} />
      </div>
      <div className={style.footerSidebarSection2} />
      <div className={style.footerSidebarSection3} />
    </div>
  );
}

export default function Footer() {
  const { t } = useTranslation();
  const keyI18n = "translations.footer";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const balcao = searchParams.get("balcao") === "true";

  const [showModalBalcaoVirtual, setShowModalBalcaoVirtual] = useState(balcao);

  const handleShowBalcaoVirtual = async () => {
    setShowModalBalcaoVirtual(true);
  };

  const handleHideBalcaoVirtual = () => {
    setShowModalBalcaoVirtual(false);
  };

  return (
    <>
      <footer className={style.footer}>
        <FooterSidebar side="left" />
        <div className={style.footerContent}>
          <div className={style.footerMain}>
            <section className={style.footerSection1}>
              <img
                className={style.footerLogo}
                src={logoPgmWhite}
                alt="Logo da PGM"
              />
              <h4 className="pgm-title-large">{t(`${keyI18n}.address`)}</h4>
              <TextLink
                className={`pgm-body-large ${style.footerAddressLink}`}
                link="https://maps.app.goo.gl/Qw2jMyByHkQwwUaYA"
                text={t(`${keyI18n}.addressLink`)}
                target="_blank"
              />
            </section>
            <section className={style.footerSection2}>
              <h4 className="pgm-title-large">
                {t(`${keyI18n}.officeHours.title`)}
              </h4>
              <div className={style.footerSchedule}>
                <div className={style.footerScheduleGroup}>
                  <h4 className="pgm-title-large">
                    {t(`${keyI18n}.officeHours.institutional`)}
                  </h4>
                  <p className="pgm-body-large">
                    {t(`${keyI18n}.officeHours.institutionalHours`)}
                  </p>
                </div>
                <div className={style.footerScheduleGroup}>
                  <h4 className="pgm-title-large">
                    {t(`${keyI18n}.officeHours.debts`)}
                  </h4>
                  <p className="pgm-body-large">
                    {t(`${keyI18n}.officeHours.debtsHours`)}
                  </p>
                </div>
                <div className={style.footerScheduleGroup}>
                  <h4 className="pgm-title-large">
                    {t(`${keyI18n}.officeHours.protocol`)}
                  </h4>
                  <p className="pgm-body-large">
                    {t(`${keyI18n}.officeHours.protocolHours`)}
                  </p>
                </div>
              </div>
            </section>
            <section className={style.footerSection3}>
              <h4 className="pgm-title-large">
                {t(`${keyI18n}.contact.title`)}
              </h4>
              <p className={`pgm-body-large ${style.footerContactDescription}`}>
                {t(`${keyI18n}.contact.debts`)}
              </p>
              <TextLink
                className={`pgm-body-large ${style.footerContactLink}`}
                link="https://api.whatsapp.com/send?phone=5585984192045"
                text={t(`${keyI18n}.contact.link`)}
                target="_blank"
              />
              <p className={`pgm-body-large ${style.footerContactPhone}`}>
                {t(`${keyI18n}.contact.callOnly`)}
              </p>
              <p className={`pgm-body-large ${style.footerContactHelp}`}>
                {t(`${keyI18n}.contact.help`)}
              </p>
              <Button
                className={style.footerContactButton}
                size="small"
                variant="elevated"
                onClick={handleShowBalcaoVirtual}
                icon={
                  <span className="material-symbols-sharp">concierge</span>
                }
              >
                {t(`${keyI18n}.contact.virtualDesk`)}
              </Button>
            </section>
          </div>
          <div className={style.footerCredits}>
            <span className="pgm-title-small">{t(`${keyI18n}.credit`)}</span>
          </div>
        </div>
        <FooterSidebar side="right" />
      </footer>
      <ModalBalcaoVirtual
        show={showModalBalcaoVirtual}
        onHide={handleHideBalcaoVirtual}
      />
    </>
  );
}
